import { canGetOrganizationThirdPartyPage } from "@/route-authorization";
export const organization = {
  routes: [
    {
      path: "/organization/thirdparty",
      meta: { rules: [canGetOrganizationThirdPartyPage] }, // TKP-150
      component: () => import("../organization-thirdparty-view"),
    },
  ],
};
